import { Form, Input } from "antd";
import React from "react";


export default function TextInputField(props) {

    const { data = {}, contact = {}, label_class = "", label_help_class = "", label_description_class = "" } = props;

    const {
        id = "",
        label = "Text",
        type = "text",
        description = "",
        placeholder = "Enter text...",
        max_length = 50,
        required = false,
        required_message = "This field is required",
    } = data;

    let defaultValue = (contact.hasOwnProperty([id])) ? contact[id] : "";

    return (<>
      
        <Form.Item  initialValue={defaultValue} extra={(description && <span className={label_description_class}>{description}</span>)} rules={[{ required: required, message: (required_message) ? <div className={label_help_class}>{required_message}</div> : <div className={label_help_class}>This field is required</div> }]} label={<div className={label_class}>{label}</div>} name={id} >
            <Input size="large" maxLength={max_length} placeholder={placeholder} />
        </Form.Item>
        </>
    )
}